module.exports = __webpack_public_path__ + "img/17_partnerships_to_achieve_the_goal_color.e7184f7a.svg";